import $ from 'jquery'
import {rpcCall} from '../../util/rpc/rpcCalls'
import {Exceptions as CommonExceptions} from '../../common/constants'
import messageResource from '../../messageResource'
import {BASE_PATH} from '../../constants'
import {throttlePromise} from '../../atUtils'
import {THROTTLE_TIME_WAIT, BACK_OFFICE_PROCESS_STATUS_URL} from './constants'

export const getPurchaseCardsDataThrottled = throttlePromise((userCount, monthCount, startDate) => {
    return rpcCall("LicensesService.getLicensesPricePreview", [userCount, monthCount, startDate], _handleError)
}, THROTTLE_TIME_WAIT)

export function getPriceForAddingUsers(licenseId, usersToAdd) {
    return rpcCall("LicensesService.getPriceForAddingUsers", [licenseId, usersToAdd], _handleError)
}

export function getLicensesPageInitialData() {
    return rpcCall("LicensesService.getLicensesInitialData", [], _handleError)
}

export function startPurchase(usersCount, period, licenseStartDateStr) {
    return rpcCall("LicensesService.startPurchaseNewLicense", [period, usersCount, licenseStartDateStr], _handleError)
}

export function startGetFree() {
    return rpcCall("LicensesService.startGetFreeLicense", [], _handleError)
}

export function startAddUsers(licenseId, additionalUsersCount) {
    return rpcCall("LicensesService.startAddUsers", [licenseId, additionalUsersCount], _handleError)
}

export function setCompanyInfo(processId, companyInfo) {
    return rpcCall("LicensesService.companyInfoSet", [processId, companyInfo], _handleError)
}

export function confirmPurchase(processId) {
    return rpcCall("LicensesService.confirmPurchase", [processId], _handleError)
}

export function confirmPurchaseWithPaymentDetails(processId, paymentDetails) {
    return rpcCall("LicensesService.confirmPurchaseWithPaymentDetails", [processId, paymentDetails], _handleError)
}

export function setNewContext(processId, context) {
    return rpcCall("LicensesService.newContextSet", [processId, context], _handleError)
}

export function setNewSegment(processId, newSegment) {
    return rpcCall("LicensesService.newSegmentSet", [processId, newSegment], _handleError)
}

export function setPromoCode(processId, code) {
    return rpcCall("LicensesService.promoCodeSet", [processId, code], _handleError)
}

export function switchToFreeVersion() {
    return rpcCall("LicensesService.switchToFreeVersion", [], _handleError)
}

export function setPaymentMethod(processId, paymentMethod) {
    return rpcCall('LicensesService.setPaymentMethod', [processId, paymentMethod], _handleError)
}

export function checkProcessStatus(processId) {
    return new Promise((resolve, reject) => {
        $.ajax({
            dataType: 'json',
            type: 'GET',
            url: `${BACK_OFFICE_PROCESS_STATUS_URL}/${processId}`,
            success: (data) => resolve(data),
            error: () => reject('Failed to check process status'),
            timeout: 60000
        })
    })
}

function _handleError(error) {
    if (error.getException() === CommonExceptions.NO_RIGHTS_FOR_REMOTE_CALL_EXCEPTION) {
        alert(messageResource.getMessage('error.js.json_rpc.no_rights'))
        window.location.href = BASE_PATH
        return true
    } else if (error.getTextStatus() === 'rpc_customException') {
        alert(error.getErrorThrown().msg)
        return true
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/apiCalls.js